<div class="footer-details" [ngClass]="screenClasses()">
  <div class="cover">
    <on-ui-cover [cover]="cover"></on-ui-cover>
  </div>
  <div class="info">
    <div class="subject">{{ subjectName }}</div>
    <div class="title">{{ title }}</div>
    <div class="more-info">
      <ng-container *ngTemplateOutlet="singleRef"></ng-container>
    </div>
  </div>
  <div class="type" *ngIf="type">{{ type | translate }}</div>
</div>

<ng-template #singleRef>
  <ul>
    <li *ngIf="meeting.begin_at">
      {{meeting.begin_at | date : 'dd MMM YYYY'}}
    </li>
    <li *ngIf="meeting.begin_at">{{meeting.begin_at | date : 'EE'}}</li>
    <li *ngIf="meeting.begin_at">{{meeting.begin_at | date : 'HH:mm'}}</li>
    <li *ngIf="duration">{{duration}} {{ 'library.user-service-card.min' | translate }}</li>
  </ul>
</ng-template>
